export default "__VITE_ASSET__caabb293__"